import { Accordion } from '@mantine/core';
import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
`;

export const Group = styled(Accordion.Item)``;

export const GroupTitle = styled.div`
  font-size: 13px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-right: 6px;
`;

export const GroupHeader = styled(Accordion.Control)``;

export const GroupContent = styled(Accordion.Panel)``;

export const Item = styled.div``;
